import { Anchor } from "@mantine/core"
import { IconExternalLink } from "@tabler/icons-react"

import { ActionIcon } from "../../atoms/ActionIcons/ActionIcon"
import { Missing } from "../Missing/Missing"

type Props = {
  value?: string
}

export const QRCodeCell = ({ value }: Props) =>
  value ? (
    <Anchor href={value} target="_blank" onClick={(e) => e.stopPropagation()}>
      <ActionIcon icon={<IconExternalLink />} />
    </Anchor>
  ) : (
    <Missing />
  )
